import React from "react";
import Header from "../Components/Header";
import heroImg from '../Images/services-intro.webp';


const Services=()=>{
    return(
        <>
         <Header
         smallHeading="Know More"
  bigHeading="OUR HAIR SERVICES"
  image={heroImg} />
        </>
    )
}

export default Services;
